import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { connectState } from '@examdojo/angular/util';
import { IconComponent } from '@examdojo/core/icon';
import { AuthService, IfUserHasRoleDirective, ProfileAvatarComponent, UserQuery } from '@examdojo/user';
import { TranslocoPipe } from '@jsverse/transloco';
import { filter, map, startWith } from 'rxjs';
import { CmsUrlParts } from '../cms/cms.model';

@Component({
  selector: 'exam-authenticated-layout',
  imports: [
    MatSidenavModule,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    IconComponent,
    ProfileAvatarComponent,
    TranslocoPipe,
    IfUserHasRoleDirective,
  ],
  templateUrl: './authenticated-layout.component.html',
  styleUrl: './authenticated-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'h-full' },
})
export class AuthenticatedLayoutComponent {
  constructor(
    private readonly userQuery: UserQuery,
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {
    // User role is now fetched by route resolvers
    // This prevents repeated API calls and ensures data is available before guards run
  }

  readonly state = connectState({
    user: this.userQuery.active$,
    isLoading: this.userQuery.selectLoading(),
    showSidenav: this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((event) => event.url),
      startWith(this.router.url),
      map((url) => {
        const shellRoutes = [
          CmsUrlParts.Questions,
          CmsUrlParts.ReferenceQuestions,
          CmsUrlParts.Sources,
          CmsUrlParts.Syllabus,
        ];
        // Show AuthenticatedLayout sidebar only when NOT in shell routes
        // Hide it when in shell routes (Questions, Reference, etc.)
        // PreviewFromJson is now in AuthenticatedLayout, so don't hide for it
        return !shellRoutes.some((route) => url.includes(`/${route}`));
      }),
    ),
  });

  readonly CmsUrlParts = CmsUrlParts;

  async signOut() {
    await this.authService.signOut();
  }
}
